
export function formatDateRelative(unixNumber: number, language: string = "en"): string {
  const date = new Date(unixNumber);
  const now = new Date();

  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  const timeFormatter = new Intl.DateTimeFormat(language, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const dateFormatter = new Intl.DateTimeFormat(language, {
    day: '2-digit',
    month: 'short',
  });

  const timeStr = timeFormatter.format(date);

  return isToday ? `Today ${timeStr}` : `${dateFormatter.format(date)} ${timeStr}`;
}



export type TimeFormat = '12h' | '24h';
export type DateFormatTemplate =
  | 'yyyy/MM/dd'
  | 'dd/MM/yyyy'
  | 'MM/dd/yyyy'
  | 'yyyy.MM.dd'
  | 'dd.MM.yyyy'
  | 'MM.dd.yyyy'
  | 'yyyy-MM-dd'
  | 'dd-MM-yyyy'
  | 'MM-dd-yyyy'
  | 'dd MMMM, yyyy'
  | 'dd MMMM yyyy'
  | 'MMMM dd, yyyy'
  | 'MMMM dd yyyy';

const pad = (n: number) => n.toString().padStart(2, '0');

const getMonthName = (month: number) =>
  new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(2000, month));

export function formatDate(milliseconds: number, template: DateFormatTemplate, timeFormat?: TimeFormat): string {

  const date = new Date(milliseconds);
  const yyyy = date.getFullYear();
  const MM = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const HH = pad(date.getHours());
  const hh = pad(date.getHours() % 12 || 12);
  const mm = pad(date.getMinutes());
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
  const MMMM = getMonthName(date.getMonth());

  let formatted: string = template;

  formatted = formatted.replace('MMMM', MMMM); // replace longer pattern first
  formatted = formatted.replace('yyyy', yyyy.toString());
  formatted = formatted.replace('dd', dd);
  formatted = formatted.replace('MM', MM);

  if (timeFormat) {
    const timeStr = timeFormat === '12h' ? `${hh}:${mm} ${ampm}` : `${HH}:${mm}`;
    formatted += ` ${timeStr}`;
  }

  return formatted;
}
